import React, { FC, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { Timeline as VisTimeline } from 'vis-timeline/dist/vis-timeline-graph2d.min';

import styles from './timeline.module.scss';
import './timeline.scss';

export type TimelineItemType = {
  id: string;
  start: string;
  content: string;
  current: boolean;
  title?: string;
};

type Props = {
  items: TimelineItemType[];
  onItemClick?: Function;
};

const formatItem = (item: {
  current: boolean;
  content: string;
  id: string;
}) => {
  const { current, content, id } = item;

  return {
    ...item,
    content: `<span class="${classNames({
      [styles['item-current']]: current,
      [styles['item-link']]: !current,
    })}" data-test-id="timeline-item-${id}">${content}</span>`,
  };
};

export const Timeline: FC<Props> = ({ children, items, onItemClick }) => {
  const timelineContainer = useRef(null);

  useEffect(() => {
    const container = timelineContainer.current;
    const formattedItems = items.map(formatItem);
    if (!container) return;

    const timeline = new VisTimeline(container, formattedItems, {
      zoomable: false,
      moveable: false,
      selectable: false,
      zoomMin: 1000000000,
      maxHeight: '500px',
      minHeight: '170px',
      showCurrentTime: true,
    });

    if (onItemClick) {
      timeline.on('click', (event: { item: string }) => {
        if (event.item) {
          const clickedItem = items.filter((item) => item.id === event.item);
          onItemClick(clickedItem[0].id);
        }
      });
    }

    return () => {
      timeline.destroy();
    };
  }, [items, onItemClick]);

  return <div ref={timelineContainer}>{children}</div>;
};
